import React, { Component } from 'react';
import { connect } from 'react-redux';
import { message } from 'antd';
import OrderReturnManagementListWrap from '../../views/order/return/management/list/OrderReturnManagementListWrap';
import { orderActions } from '../../store/modules/order';
import {
  ORDER_RETURN_MANAGEMENT_LIST_SEARCH_OPTION_MODEL,
  ORDER_RETURN_MANAGEMENT_MODEL,
} from '../../store/modules/order/models';
import { _LIST_PAGINATION_MODEL } from '../../store/modules/app/models';
import { NO_DATA_ON_EXCEL_DOWNLOAD_WARNING_TEXT } from '../../constants/service/common/utilConstants';
import { INVALID_REQUIRED_SELECT_ORDER_ITEM_MESSAGE } from '../../constants/service/invalidMsg/orderInvalidMsg';
import { ORDER_RETURN_STATUS, RETURN_PROGRESS_RETURN_STATUS_LIST } from '../../constants/service/app/orderConstants';
import { checkIsNonSelectedList, asyncSimpleModal, setIfNull } from '../../lib/common';
import moment, { addBusinessDays } from '../../lib/moment';

class OrderReturnManagementContainer extends Component {
  componentDidMount() {
    this.initiate();
  }

  initiate = () => {
    const { setData } = this.props;

    this.getList({
      searchOption: ORDER_RETURN_MANAGEMENT_LIST_SEARCH_OPTION_MODEL,
      pagination: _LIST_PAGINATION_MODEL,
    });

    /**
     *  검색 박스 초기화
     */
    setData({
      path: ['orderReturnManagement'],
      value: ORDER_RETURN_MANAGEMENT_MODEL,
    });
  };

  getList = (data) => {
    const { orderReturnManagement, getOrderReturnManagementList } = this.props;
    const { orderReturnManagementList } = orderReturnManagement;

    getOrderReturnManagementList({
      ...orderReturnManagementList,
      ...data,
    });
  };

  /**
   *  전체 엑셀 다운로드
   */
  getAllListExcelDownload = () => {
    const { orderReturnManagement, getOrderReturnManagementAllListExcelDownload, adminInfo } = this.props;
    const { searchOption, filterOption } = orderReturnManagement.orderReturnManagementList;

    getOrderReturnManagementAllListExcelDownload({
      email: adminInfo.email,
      fileName: '반품관리 전체 리스트',
      searchOption,
      filterOption,
    });
  };

  /**
   *  선택 엑셀 다운로드
   */
  getSelectedListExcelDownload = () => {
    const { orderReturnManagement, getOrderReturnManagementSelectedListExcelDownload } = this.props;
    const { orderReturnManagementSelectedList, orderReturnManagementList } = orderReturnManagement;
    const { searchOption, filterOption } = orderReturnManagementList;

    if (!orderReturnManagementSelectedList.length) {
      message.error(NO_DATA_ON_EXCEL_DOWNLOAD_WARNING_TEXT);
      return;
    }

    getOrderReturnManagementSelectedListExcelDownload({
      fileName: '반품관리 선택 리스트',
      searchOption,
      filterOption,
      selectedOrderItemList: orderReturnManagementSelectedList,
    });
  };

  /**
   * 상품 주문 취소 선택 callback
   */
  onCheckOrderItem = (list) => {
    const { setData } = this.props;

    setData({
      path: ['orderReturnManagement', 'orderReturnManagementSelectedList'],
      value: list,
    });
  };

  /**
   *  반품 수거 완료
   *  [반품 요청(0)]
   */
  completeCollectionOrderReturn = async () => {
    const { orderReturnManagement, completeCollectionOrderReturn } = this.props;
    const { orderReturnManagementSelectedList, orderReturnManagementList } = orderReturnManagement;

    /**
     * 선택된 상품 주문서가 있는지 체크
     */
    const isSelected = checkIsNonSelectedList(
      orderReturnManagementSelectedList,
      INVALID_REQUIRED_SELECT_ORDER_ITEM_MESSAGE,
    );
    if (!isSelected) return;

    /**
     *  상품 주문 반품 상태가 반품 요청(0)인 경우에만
     *  반품 수거 완료처리를 할 수 있음
     */
    const targetOrderReturnItemList = orderReturnManagementList.list.filter(
      (item) =>
        orderReturnManagementSelectedList.includes(item.id) &&
        item.orderItemReturnStatus === ORDER_RETURN_STATUS.REQUEST,
    );

    /**
     *  선택한 상품 주문서에 반품 요청(0)건이 없을 경우
     */
    if (!targetOrderReturnItemList.length) {
      await asyncSimpleModal({
        type: 'error',
        title: '수거 완료처리',
        message: '선택한 주문은 수거 완료처리를 할 수 없습니다.',
      });
      return;
    }

    /**
     *  선택한 상품 주문서에 결제 반품 요청(0)건이 있을 경우
     *  확인을 누르면, 진행을 하고, 취소를 누르면 진행을 하지 않는다.
     */
    const completeCollectionConfirmResult = await asyncSimpleModal({
      type: 'confirm',
      title: '수거 완료처리',
      message:
        `선택하신 (${orderReturnManagementSelectedList.length}개) 상품 주문건 증 수거 완료처리가\n` +
        `가능한 상품 주문은 (${targetOrderReturnItemList.length}개)입니다.\n` +
        '진행하시겠습니까?',
      okText: '수거 완료처리',
    });

    /**
     *  선택된 반품 요청(0) 상품 리스트를
     *  서버로 전송해서 반품 수거 완료처리로 업데이트함
     */
    if (completeCollectionConfirmResult) {
      completeCollectionOrderReturn({
        orderItemIdList: targetOrderReturnItemList.map((item) => item.orderItemId),
      });
    }
  };

  /**
   *  수거 실패 -> 반품 거부 처리하기
   * [반품 요청(0)]
   */
  failCollectionRejectOrderReturn = async () => {
    const { orderReturnManagement, toggleModal } = this.props;
    const { orderReturnManagementSelectedList, orderReturnManagementList } = orderReturnManagement;

    /**
     * 선택된 상품 주문서가 있는지 체크
     */
    const isSelected = checkIsNonSelectedList(
      orderReturnManagementSelectedList,
      INVALID_REQUIRED_SELECT_ORDER_ITEM_MESSAGE,
    );
    if (!isSelected) return;

    /**
     *  수거 실패 -> 반품 거부는 1 건씩만 가능합니다.
     */
    if (orderReturnManagementSelectedList.length > 1) {
      await asyncSimpleModal({
        type: 'error',
        title: '수거 실패 -> 반품 거부 처리',
        message: '1건에 대해서만 처리가 가능합니다.',
      });
      return;
    }

    /**
     *  상품 주문 반품 상태가 반품 요청(0)인 경우에만
     *  수거 실패 -> 반품 거부 처리를 할 수 있음
     */
    const targetOrderReturnItem = orderReturnManagementList.list.find(
      (item) =>
        orderReturnManagementSelectedList.includes(item.id) &&
        item.orderItemReturnStatus === ORDER_RETURN_STATUS.REQUEST,
    );

    /**
     *  선택한 상품 주문서에 반품 요청(0)건이 없을 경우
     */
    if (!targetOrderReturnItem) {
      await asyncSimpleModal({
        type: 'error',
        title: '수거 실패 -> 반품 거부 처리',
        message: '반품 요청된 상품 주문건에 대해서만 수거 실패 -> 반품 거부 처리가 가능합니다.',
      });
      return;
    }

    /**
     *  반품 요청일 +7 이후 건에만 수거 실패 -> 반품 거부 처리가 가능하다.
     */
    if (moment.duration(moment().diff(addBusinessDays(targetOrderReturnItem.requestReturnDate, 7))).asDays() < 0) {
      await asyncSimpleModal({
        type: 'error',
        title: '수거 실패 -> 반품 거부 처리',
        message: '반품 요청일 +7일 (영업일 기준) 이후 건에 대해서만 처리가 가능합니다.',
      });
      return;
    }

    /**
     *  관리자에게 확인 모달을 띄운다.
     *  확인을 누르면, 진행을 하고, 취소를 누르면 진행을 하지 않는다.
     */
    const failCollectionRejectReturnConfirmResult = await asyncSimpleModal({
      type: 'confirm',
      title: '한번 더 확인해주세요',
      message:
        '1. 구매자에게 발송 여부를 확인해주세요\n' + '2. 구매자에게 사유를 먼저 안내하고, 거부 처리를 진행해주세요.',
    });

    /**
     *  수거 실패 -> 반품 거부 처리를 위해 반품 거부 상세 사유를
     *  입력하는 모달을 열도록 함
     */
    if (failCollectionRejectReturnConfirmResult) {
      toggleModal({
        name: 'rejectReturnModal',
        data: {
          orderItemId: targetOrderReturnItem.orderItemId,
          productName: targetOrderReturnItem.productName,
          productPrice: targetOrderReturnItem.productPrice,
          /**
           *  수거 실패 -> 반품 거부, 그냥 반품 거부는 알림톡 내용이 다르다
           *  returnStatus 값으로 위의 두가지를 판단이 가능하므로
           *  returnStatus 값을 넘긴다.
           */
          orderItemReturnStatus: targetOrderReturnItem.orderItemReturnStatus,
        },
      });
    }
  };

  /**
   * 반품 사유 수정하기
   * [수거 완료(3), 반품 처리 지연(4)]
   */
  editReasonOrderReturn = async () => {
    const { orderReturnManagement, getPreparationOrderReturnEditReason } = this.props;
    const { orderReturnManagementSelectedList, orderReturnManagementList } = orderReturnManagement;

    /**
     * 선택된 상품 주문서가 있는지 체크
     */
    const isSelected = checkIsNonSelectedList(
      orderReturnManagementSelectedList,
      INVALID_REQUIRED_SELECT_ORDER_ITEM_MESSAGE,
    );
    if (!isSelected) return;

    /**
     *  반품 사유 수정하기는 1 건씩만 가능합니다.
     */
    if (orderReturnManagementSelectedList.length > 1) {
      await asyncSimpleModal({
        type: 'error',
        title: '반품 사유 수정하기',
        message: '1건에 대해서만 처리가 가능합니다.',
      });
      return;
    }

    /**
     *  상품 주문 반품 상태가 수거 완료(3), 반품 처리 지연(4)인 경우에만
     *  교환으로 변경을 할 수 있음
     */
    const targetOrderReturnItem = orderReturnManagementList.list.find(
      (item) =>
        orderReturnManagementSelectedList.includes(item.id) &&
        RETURN_PROGRESS_RETURN_STATUS_LIST.includes(item.orderItemReturnStatus),
    );

    /**
     *  선택한 상품 주문서에 수거 완료(3), 반품 처리 지연(4)건이 없을 경우
     */
    if (!targetOrderReturnItem) {
      await asyncSimpleModal({
        type: 'error',
        title: '반품 사유 수정',
        message: '반품 수거 완료된 상품 주문건에 대해서만 반품 사유 수정이 가능합니다.',
      });
      return;
    }

    /**
     *  반품 사유 수정 하기 전 필요한 데이터들을
     *  백단에서 가져온다
     */
    getPreparationOrderReturnEditReason({
      orderItemId: targetOrderReturnItem.orderItemId,
    });
  };

  /**
   * 반품 승인 처리
   * [수거 완료(3), 반품 처리 지연(4)]
   */
  completeOrderReturn = async () => {
    const { orderReturnManagement, toggleModal } = this.props;
    const { orderReturnManagementSelectedList, orderReturnManagementList } = orderReturnManagement;

    /**
     * 선택된 상품 주문서가 있는지 체크
     */
    const isSelected = checkIsNonSelectedList(
      orderReturnManagementSelectedList,
      INVALID_REQUIRED_SELECT_ORDER_ITEM_MESSAGE,
    );
    if (!isSelected) return;

    /**
     *  반품 승인 처리는 1 건씩만 가능함
     */
    if (orderReturnManagementSelectedList.length > 1) {
      await asyncSimpleModal({
        type: 'error',
        title: '반품 승인 처리',
        message: '1건에 대해서만 처리가 가능합니다.',
      });
      return;
    }

    /**
     *  상품 주문 반품 상태가 수거 완료(3), 반품 처리 지연(4)인 경우에만
     *  반품 승인 처리를 할 수 있음
     */
    const targetOrderReturnItem = orderReturnManagementList.list.find(
      (item) =>
        orderReturnManagementSelectedList.includes(item.id) &&
        RETURN_PROGRESS_RETURN_STATUS_LIST.includes(item.orderItemReturnStatus),
    );

    /**
     *  선택한 상품 주문서가 수거 완료(3), 반품 처리 지연(4)건이 아닐 경우
     */
    if (!targetOrderReturnItem) {
      await asyncSimpleModal({
        type: 'error',
        title: '반품 승인 처리',
        message: '반품 수거 완료된 상품 주문건에 대해서만 반품 승인 처리가 가능합니다.',
      });
      return;
    }

    /**
     *  반품 승인 처리를 위해
     *  추가 청구비,
     *  판매자의 활불 예상 금액 책정사유,
     *  판매자가 책정한 환불 예정 금액을
     *  정하기 위해 모달을 띄움
     */
    toggleModal({
      name: 'completeReturnModal',
      data: {
        /**
         *  상품 주문번호
         */
        orderItemId: targetOrderReturnItem.orderItemId,
        /**
         *  상품명
         */
        productName: targetOrderReturnItem.productName,
        /**
         *  상품 정가
         */
        productPrice: targetOrderReturnItem.productPrice,
        /**
         *  구매자 전화번호
         */
        buyerPhone: targetOrderReturnItem.buyerPhone,
        /**
         *  반품 사유 타입
         */
        returnType: targetOrderReturnItem.returnType,
        /**
         *  주문 반품 번호
         */
        orderReturnId: targetOrderReturnItem.orderReturnId,
        /**
         *  구매자 이름
         */
        buyerName: targetOrderReturnItem.buyerName,
        /**
         *  구매자 계정
         */
        buyerAccount: targetOrderReturnItem.buyerAccount,
        /**
         *  반품 사유
         */
        returnReason: targetOrderReturnItem.returnReason,
        /**
         *  반품 요청 날짜
         */
        requestReturnDate: targetOrderReturnItem.requestReturnDate,
        /**
         *  결제금액
         */
        totalPrice: targetOrderReturnItem.totalPrice,
        /**
         *  최초무료배송비
         */
        returnDeliveryFee: targetOrderReturnItem.returnDeliveryFee,
        /**
         *  구매자가 예상하는 환불 금액
         */
        refundExpectAmount: setIfNull(targetOrderReturnItem.refundExpectAmount, 0),
        /**
         *  판매자 부담 추가배송비
         */
        sellerDeliveryExtraFee: setIfNull(targetOrderReturnItem.sellerDeliveryExtraFee, 0),
        /**
         *  고객 부담 추가배송비
         */
        buyerDeliveryExtraFee: targetOrderReturnItem.buyerDeliveryExtraFee,
        /**
         *  구매 결제 방법
         */
        payMethod: targetOrderReturnItem.payMethod,
        /**
         *  구매 결제 방법이 가상계좌인 경우 구매자가 환불 받을 은행명
         */
        bankName: targetOrderReturnItem.bankName,
        /**
         *  구매 결제 방법이 가상계좌인 경우 구매자가 환불 받을 계좌번호
         */
        bankNumber: targetOrderReturnItem.bankNumber,
        /**
         *  구매 결제 방법이 가상계좌인 경우 구매자가 환불 받을 계좌의 예금주
         */
        bankHolder: targetOrderReturnItem.bankHolder,
      },
    });
  };

  /**
   * 반품 거부 처리
   * [수거 완료(3), 반품 처리 지연(4)]
   */
  rejectOrderReturn = async () => {
    const { orderReturnManagement, toggleModal } = this.props;
    const { orderReturnManagementSelectedList, orderReturnManagementList } = orderReturnManagement;

    /**
     * 선택된 상품 주문서가 있는지 체크
     */
    const isSelected = checkIsNonSelectedList(
      orderReturnManagementSelectedList,
      INVALID_REQUIRED_SELECT_ORDER_ITEM_MESSAGE,
    );
    if (!isSelected) return;

    /**
     *  반품 거부는 1 건씩만 가능합니다.
     */
    if (orderReturnManagementSelectedList.length > 1) {
      await asyncSimpleModal({
        type: 'error',
        title: '반품 거부 처리',
        message: '1건에 대해서만 처리가 가능합니다.',
      });
      return;
    }

    /**
     *  상품 주문 반품 상태가 수거 완료(3), 반품 처리 지연(4)인 경우에만
     *  반품 거부 처리를 할 수 있음
     */
    const targetOrderReturnItem = orderReturnManagementList.list.find(
      (item) =>
        orderReturnManagementSelectedList.includes(item.id) &&
        RETURN_PROGRESS_RETURN_STATUS_LIST.includes(item.orderItemReturnStatus),
    );

    /**
     *  선택한 상품 주문서가 수거 완료(3), 반품 처리 지연(4)건이 아닐 경우
     */
    if (!targetOrderReturnItem) {
      await asyncSimpleModal({
        type: 'error',
        title: '반품 거부 처리',
        message: '반품 수거 완료된 상품 주문건에 대해서만 반품 거부 처리가 가능합니다.',
      });
      return;
    }

    /**
     *  반품 거부 처리를 위해 반품 거부 상세 사유를
     *  입력하는 모달을 열도록 함
     */
    toggleModal({
      name: 'rejectReturnModal',
      data: {
        orderItemId: targetOrderReturnItem.orderItemId,
        productName: targetOrderReturnItem.productName,
        productPrice: targetOrderReturnItem.productPrice,
        /**
         *  수거 실패 -> 반품 거부, 그냥 반품 거부는 알림톡 내용이 다르다
         *  returnStatus 값으로 위의 두가지를 판단이 가능하므로
         *  returnStatus 값을 넘긴다.
         */
        orderItemReturnStatus: targetOrderReturnItem.orderItemReturnStatus,
      },
    });
  };

  /**
   * 반품에서 교환으로 변경하기
   * [수거 완료(3), 반품 처리 지연(4)]
   */
  changeReturnToExchange = async () => {
    const { orderReturnManagement, changeReturnToExchange } = this.props;
    const { orderReturnManagementSelectedList, orderReturnManagementList } = orderReturnManagement;

    /**
     * 선택된 상품 주문서가 있는지 체크
     */
    const isSelected = checkIsNonSelectedList(
      orderReturnManagementSelectedList,
      INVALID_REQUIRED_SELECT_ORDER_ITEM_MESSAGE,
    );
    if (!isSelected) return;

    /**
     *  교환으로 변경은 1 건씩만 가능합니다.
     */
    if (orderReturnManagementSelectedList.length > 1) {
      await asyncSimpleModal({
        type: 'error',
        title: '교환으로 변경',
        message: '1건에 대해서만 처리가 가능합니다.',
      });
      return;
    }

    /**
     *  상품 주문 반품 상태가 수거 완료(3), 반품 처리 지연(4)인 경우에만
     *  교환으로 변경을 할 수 있음
     */
    const targetOrderReturnItem = orderReturnManagementList.list.find(
      (item) =>
        orderReturnManagementSelectedList.includes(item.id) &&
        RETURN_PROGRESS_RETURN_STATUS_LIST.includes(item.orderItemReturnStatus),
    );

    /**
     *  선택한 상품 주문서에 수거 완료(3), 반품 처리 지연(4)건이 없을 경우
     */
    if (!targetOrderReturnItem) {
      await asyncSimpleModal({
        type: 'error',
        title: '교환으로 변경',
        message: '반품 수거 완료된 상품 주문건에 대해서만 교환으로 변경이 가능합니다.',
      });
      return;
    }

    /**
     *  선택한 상품 주문서에 수거 완료(3), 반품 처리 지연(4) 건이 있을 경우
     *  확인을 누르면, 진행을 하고, 취소를 누르면 진행을 하지 않는다.
     */
    const changeExchangeConfirmResult = await asyncSimpleModal({
      type: 'confirm',
      title: '교환으로 변경',
      message: `선택하신 상품 주문번호 ${targetOrderReturnItem.orderItemId} 를 \n` + '교환으로 변경을 하시겠습니까?',
      okText: '교환으로 변경',
    });

    /**
     *  반품에서 교환으로 변경을 하도록 함
     */
    if (changeExchangeConfirmResult) {
      changeReturnToExchange({
        orderItemId: targetOrderReturnItem.orderItemId,
      });
    }
  };

  render() {
    const { orderReturnManagement, setData, getOrderReturnAttachment } = this.props;

    return (
      <OrderReturnManagementListWrap
        orderReturnManagement={orderReturnManagement}
        setData={setData}
        getOrderReturnAttachment={getOrderReturnAttachment}
        getList={this.getList}
        getAllListExcelDownload={this.getAllListExcelDownload}
        getSelectedListExcelDownload={this.getSelectedListExcelDownload}
        onCheckOrderItem={this.onCheckOrderItem}
        completeCollectionOrderReturn={this.completeCollectionOrderReturn}
        failCollectionRejectOrderReturn={this.failCollectionRejectOrderReturn}
        editReasonOrderReturn={this.editReasonOrderReturn}
        completeOrderReturn={this.completeOrderReturn}
        rejectOrderReturn={this.rejectOrderReturn}
        changeReturnToExchange={this.changeReturnToExchange}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminInfo: state.app.adminInfo,
    orderReturnManagement: state.order.orderReturnManagement,
  };
};

const mapDispatchToProps = {
  setData: orderActions.setData,
  toggleModal: orderActions.toggleModal,
  getOrderReturnManagementList: orderActions.getOrderReturnManagementList,
  getOrderReturnManagementAllListExcelDownload: orderActions.getOrderReturnManagementAllListExcelDownload,
  getOrderReturnManagementSelectedListExcelDownload: orderActions.getOrderReturnManagementSelectedListExcelDownload,
  completeCollectionOrderReturn: orderActions.completeCollectionOrderReturn,
  getPreparationOrderReturnEditReason: orderActions.getPreparationOrderReturnEditReason,
  changeReturnToExchange: orderActions.changeReturnToExchange,
  getOrderReturnAttachment: orderActions.getOrderReturnAttachment,
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderReturnManagementContainer);
